import { Pressable, Text, View } from 'react-native'
import { styled } from '~/utils'

export const MenuItem = styled(Pressable, theme => {
  return {
    base: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-evenly',
      alignItems: 'center',
      flex: 1,
      gap: theme.spacingStackOnepulse,
      minWidth: theme.sizingHuge,
      height: theme.sizingHuge,
      paddingBottom: 8,
      maxWidth: theme.sizingColossal,
      backgroundColor: theme.colorBrowsingFillOnbrandEnabled,
      borderWidth: theme.borderWidthNone,
      borderColor: theme.colorBrowsingBorderOnbrandEnabled,
    },
    variants: {
      active: {
        true: {
          backgroundColor: theme.colorBrowsingFillOnbrandActivated,
          borderWidth: theme.borderWidthNone,
          borderTopWidth: theme.borderWidthHalfpulse,
          borderColor: theme.colorBrowsingBorderOnbrandActivated,
          marginTop: -2,
        },
      },
      hasPressed: {
        true: {
          backgroundColor: theme.colorBrowsingFillOnbrandPressed,
          borderWidth: theme.borderWidthNone,
          borderTopWidth: theme.borderWidthHalfpulse,
          borderColor: theme.colorBrowsingBorderOnbrandActivated,
          marginTop: -2,
        },
      },
      hasFocused: {
        true: {
          borderColor: theme.colorActionBorderFocused,
          borderWidth: theme.borderWidthHalfpulse,
        },
      },
      disabled: {
        true: {
          backgroundColor: theme.colorBrowsingFillOnbrandDisabled,
          borderColor: theme.colorBrowsingBorderOnbrandDisabled,
          borderWidth: theme.borderWidthNone,
        },
      },
    },
  }
})

export const Content = styled(View, theme => {
  return {
    base: {
      display: 'flex',
      flex: 1,
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      minWidth: theme.sizingHuge,
      gap: theme.spacingStackOnepulse,
      backgroundColor: theme.colorBrowsingFillOnbrandEnabled,
      borderWidth: theme.borderWidthNone,
      borderColor: theme.colorBrowsingBorderOnbrandEnabled,
    },
    variants: {
      active: {
        true: {
          backgroundColor: theme.colorBrowsingFillOnbrandActivated,
          borderWidth: theme.borderWidthNone,
          borderColor: theme.colorBrowsingBorderOnbrandEnabled,
          borderTopWidth: theme.borderWidthHalfpulse,
          borderTopColor: theme.colorBrowsingBorderOnbrandActivated,
        },
      },
      hasPressed: {
        true: {
          backgroundColor: 'rgba(230, 245, 233, 1)',
          borderColor: theme.colorBrowsingBorderOnbrandEnabled,
          borderWidth: theme.borderWidthNone,
        },
      },
      hasFocused: {
        true: {
          borderColor: theme.colorActionBorderFocused,
          borderWidth: theme.borderWidthHalfpulse,
        },
      },
      disabled: {
        true: {
          backgroundColor: theme.colorBrowsingFillOnbrandDisabled,
          borderColor: theme.colorBrowsingBorderOnbrandDisabled,
          borderWidth: theme.borderWidthNone,
        },
      },
    },
    compoundVariants: [
      {
        variants: {
          disabled: true,
          active: true,
        },
        css: {
          backgroundColor: theme.colorBrowsingFillOnbrandDisabled,
          borderColor: theme.colorBrowsingBorderOnbrandDisabled,
          borderWidth: theme.borderWidthNone,
          borderTopWidth: theme.borderWidthNone,
          borderTopColor: theme.colorBrowsingBorderOnbrandDisabled,
        },
      },
    ],
  }
})

export const Label = styled(Text, theme => {
  return {
    base: {
      color: theme.colorBrowsingTextDefault,
      fontFamily: theme.fontFamily.semiBold,
      fontSize: theme.fontSizeThreepulse,
      textTransform: 'capitalize',
      textAlign: 'center',
      width: '100%',
    },
    variants: {
      active: {
        true: {
          color: theme.colorBrowsingTextActivated,
        },
      },
      hasPressed: {
        true: {
          color: theme.colorBrowsingTextPressed,
        },
      },
      hasFocused: {
        true: {
          color: theme.colorBrowsingTextDefault,
        },
      },
      disabled: {
        true: {
          color: theme.colorBrowsingTextDisabled,
        },
      },
    },
    compoundVariants: [
      {
        variants: {
          disabled: true,
          hasFocused: false,
          active: true,
        },
        css: {
          color: theme.colorBrowsingTextDisabled,
        },
      },
      {
        variants: {
          disabled: true,
          hasFocused: true,
          active: true,
        },
        css: {
          color: theme.colorBrowsingTextDisabled,
        },
      },
      {
        variants: {
          hasPressed: true,
          active: true,
        },
        css: {
          color: theme.colorBrowsingTextActivated,
        },
      },
    ],
  }
})
